module.exports = __webpack_public_path__ + "static/media/home-bk-wall-mob.d8628d53.jpg";